import React from 'react'
import {
  List,
  Filter,
  useListRepository,
  useFilter,
  DatePicker
} from 'elentari'
import { Field } from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import relatoriosRepository from './RelatoriosRepository'
import { CustomAutocomplete } from '../../components'
import moment from 'moment'
import { TextField } from 'final-form-material-ui'
import { IconButton, Tooltip } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'

export const TIPOS = [
  { label: 'Solicitação', value: 'solicitacao' },
  { label: 'Tarefa', value: 'tarefa' }
]

const formatTipo = data => TIPOS.find(tipo => tipo.value === data)?.label

const RelatorioFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={3} xs={12}>
          <Field
            name="descricao"
            label="Descrição"
            fullWidth
            component={TextField}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="usuarioId"
            label="Usuário"
            component={UsuarioAutocomplete}
            hideEmpty
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="tipo"
            label="Tipo"
            component={CustomAutocomplete}
            options={TIPOS}
            hideEmpty
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            component={DatePicker}
            label="Data Criação"
            name="createdAt"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}
const Relatorios = ({ ...props }) => {
  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      descricao: {
        label: 'Descrição'
      },
      usuario: {
        label: 'Usuário',
        format: data => data.usuario
      },
      tipo: {
        label: 'Tipo',
        format: data => formatTipo(data)
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm')
      },
      caminho: {
        label: '',
        format: data => (
          <Tooltip placement="right" title="Download" arrow>
            <IconButton
              title="Download"
              variant="outlined"
              disabled={false}
              onClick={() => window.open(data, '_blank')}
            >
              <GetAppIcon />
            </IconButton>
          </Tooltip>
        ),
        align: 'right'
      }
    }
  }

  const listHook = useListRepository({
    repository: relatoriosRepository,
    defaultSort: 'createdAt desc',
    path: 'relatorios'
  })
  return (
    <>
      <RelatorioFilter />
      <List
        {...props}
        {...listHook}
        stickyHeader
        adjustToScreenHeight
        removeItem={null}
        onClickEdit={null}
        onClickView={null}
        onClickNew={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default Relatorios
